var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{ref:"editor",tag:"component",attrs:{"mode":_vm.mode,"value":_vm.itemRevision,"view":_vm.view,"comments":_vm.comments},on:{"create:draft":_vm.createHotfixDraft,"copyItem":_vm.createDraftFromItem,"update:view":function($event){_vm.view=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }